import React__default, { useState } from 'react';
import { Button } from '../atoms/Button.js';
import { Text } from '../atoms/Text.js';
import { InfoIcon } from '../icons/InfoIcon.js';
import { PopupTrigger, Popup } from './Popup.js';
import './RichDescription.scss';

const RichDescription = ({ children, lines, helperText, helperTextColor = 'secondary', modal, className, ariaLabel, textSize, textColor, }) => {
    const [isExpanded, setIsExpanded] = useState(false);
    // Determine variant priority: modal > clamp > helper
    const variant = modal ? 'modal' : lines ? 'clamp' : helperText ? 'helper' : 'default';
    const isClampable = variant === 'clamp';
    // Map color prop to CSS variable for icon
    const getIconColorVar = (color) => {
        const colorMap = {
            primary: 'var(--rev-color-textPrimary)',
            secondary: 'var(--rev-color-textSecondary)',
            tertiary: 'var(--rev-color-textTertiary)',
            error: 'var(--rev-color-textDestructive)',
            success: 'var(--rev-color-textSuccess)',
            warning: 'var(--rev-color-textWarning)',
            information: 'var(--rev-color-textInformation)',
        };
        return colorMap[color || 'secondary'] || colorMap.secondary;
    };
    return (React__default.createElement("div", { "data-rev-component": 'rich-description', className: className, "aria-label": ariaLabel },
        React__default.createElement("div", { className: 'rich-description-text-wrapper--rev' },
            React__default.createElement("div", { className: 'rich-description-text--rev', "data-clamp": isClampable ? 'true' : 'false', "data-expanded": isExpanded ? 'true' : 'false', style: isClampable ? { ['--rd-lines']: lines } : undefined },
                React__default.createElement(Text, { size: textSize, color: textColor }, children))),
        variant === 'clamp' && (React__default.createElement("div", { className: 'rich-description-toggle--rev' },
            React__default.createElement(Button, { variant: 'underlined', onPress: () => setIsExpanded((v) => !v), ariaExpanded: isExpanded, className: 'rich-description-toggle-link--rev' }, isExpanded ? 'View less' : 'View more'))),
        variant === 'modal' && modal && (React__default.createElement("div", { className: 'rich-description-modal-link--rev' },
            React__default.createElement(PopupTrigger, null,
                React__default.createElement(Button, { variant: 'underlined' }, modal.linkText),
                React__default.createElement(Popup, { title: modal.linkText, contentPadding: { all: '24' }, size: modal.size ?? 'large' }, modal.component)))),
        variant === 'helper' && helperText && (React__default.createElement("div", { className: 'rich-description-helper--rev' },
            React__default.createElement("div", { "aria-hidden": true, className: 'rich-description-helper-icon--rev', style: { color: getIconColorVar(helperTextColor) } },
                React__default.createElement(InfoIcon, null)),
            React__default.createElement(Text, { size: textSize, color: helperTextColor, className: 'rich-description-helper-text--rev' }, helperText)))));
};
RichDescription.displayName = 'RichDescription';

export { RichDescription };
//# sourceMappingURL=RichDescription.js.map
